import Loader from "react-loader-spinner";
import { useForm } from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import { CheckSquare, DashCircle, Search } from "react-bootstrap-icons";
import { searchAccountsLevel1 } from "../store/api/DocumentsAPI";
import { Modal, Row, Form, Button, Table, Col } from "react-bootstrap";
const ModalAccountsLevel1 = (props) => {
    const { popData, setPopData } = props;
    const { show, setAccData } = popData;

    const resultTable = useRef();
    const currentRowIndex = useRef(0);
    const frmSearchAccL2 = useRef();
    const [error, setError] = useState(null);
    const [resultList, getList] = useState([]);
    const { handleSubmit, register } = useForm();

    function close() {
        setAccData(null);
        setPopData({
            show: false
        })
    }
    function select(row) {
        if (!row) {
            let err = null;
            if (currentRowIndex.current < 1) {
                err = "ردیفی انتخاب نشده است";
            }
            setError(err);
            if (err) {
                return;
            }
            const item = resultList[currentRowIndex.current - 1];
            currentRowIndex.current = 0;
            if (setAccData) {
                setAccData(item);
            }
        }
        else {
            if (setAccData) {
                setAccData(row);
            }
        }
        setPopData({ show: false });
    }
    function tableKeyDown(e) {
        if (!show || !e.target || (e.target.form !== frmSearchAccL2.current && e.target.firstChild?.id !== "ModalAccLevel1")) {
            return;
        }
        if (e.keyCode === 32) {
            select();
        }
        if (e.keyCode === 27) {
            close();
        }
        else if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            if (resultTable.current.rows.length > 0) {
                if (e.key === "ArrowDown" && currentRowIndex.current === resultTable.current.rows.length - 1) {
                    currentRowIndex.current = 0;
                }
                else if (e.key === "ArrowUp" && currentRowIndex.current <= 1) {
                    currentRowIndex.current = resultTable.current.rows.length;
                }
                if (e.key === "ArrowDown") {
                    currentRowIndex.current++;
                }
                else {
                    currentRowIndex.current--;
                }
                if (e.key === "ArrowDown" && currentRowIndex.current > 1) {
                    resultTable.current.rows[currentRowIndex.current - 1].className = "resultTableRow";
                }
                else if (e.key === "ArrowDown" && currentRowIndex.current === 1) {
                    resultTable.current.rows[resultTable.current.rows.length - 1].className = "resultTableRow";
                }
                if (e.key === "ArrowUp" && currentRowIndex.current < resultTable.current.rows.length - 1) {
                    resultTable.current.rows[currentRowIndex.current + 1].className = "resultTableRow";
                }
                else if (e.key === "ArrowUp" && currentRowIndex.current === resultTable.current.rows.length - 1) {
                    resultTable.current.rows[1].className = "resultTableRow";
                }
                resultTable.current.rows[currentRowIndex.current].className = "selectedResultTableRow";
            }
        }
    }
    function rowClick(key) {
        if (currentRowIndex.current !== 0) {
            resultTable.current.rows[currentRowIndex.current].className = "resultTableRow";
        }
        currentRowIndex.current = key;
        resultTable.current.rows[key].className = "selectedResultTableRow";

    }
    function search(data) {
        searchAccountsLevel1(data.AccountName, data.AccountCode, getList);
    }
    useEffect(() => {
        const input = document.getElementById("inputAccCodeL2Search");
        input?.focus();
        document.addEventListener('keydown', tableKeyDown);
        return () => {
            document.removeEventListener('keydown', tableKeyDown);
        }
    }, [show, resultList])
    return (
        <Modal show={show} onHide={() => { }} id="ModalAccLevel1">
            <Modal.Header className="headerStyle">انتخاب حساب کل</Modal.Header>
            <Modal.Body className="bodyStyle">
                <form onSubmit={handleSubmit(search)} ref={frmSearchAccL2}>
                    <Row>
                        <Col md={5} className="form-group" style={{ padding: "5px", marginTop: 0 }}>
                            <Form.Control placeholder="کد حساب" name="AccountCode" ref={register({})} id="inputAccCodeL2Search"/>
                        </Col>
                        <Col md={5} className="form-group" style={{ padding: "5px", marginTop: 0 }}>
                            <Form.Control placeholder="نام حساب" name="AccountName" ref={register({})} />
                        </Col>
                        <Col md={2} style={{ padding: "2px", marginTop: "7px" }} className="form-group">
                            <Button type="submit" className="group-Btn"><Search size={15} /></Button>
                        </Col>
                    </Row>
                </form>
                <Table className="mt-2" ref={resultTable}>
                    <thead>
                        <tr style={{ padding: "0" }}>
                            <th>کد حساب</th>
                            <th>نام حساب</th>
                        </tr>
                    </thead>
                    <tbody>
                        {resultList === "PENDING" &&
                            <tr>
                                <td colSpan={3} style={{ textAlign: "center" }}>
                                    <Loader type="BallTriangle" color="#bb1370" width="25" height="25" />
                                </td>
                            </tr>
                        }
                        {resultList && Array.isArray(resultList) && resultList.map((item, i) => {
                            return (
                                <tr className='resultTableRow' key={i} onClick={() => rowClick(i + 1)} onDoubleClick={() => select(item)}>
                                    <td>{item.AccountCode}</td>
                                    <td>{item.AccountName}</td>
                                </tr>)
                        })
                        }
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer style={{ justifyContent: "flex-start", padding:"5px" }} className="bodyStyle">
                <Button className='group-Btn' onClick={()=>select()}><CheckSquare size={16} />&nbsp;انتخاب حساب</Button>
                <Button variant="danger" className='group-Btn' onClick={close}><DashCircle size={16} />&nbsp;انصراف</Button>
            </Modal.Footer>
        </Modal>
    )
}
export default ModalAccountsLevel1;